import { useCallback, useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api, errorMessage } from "../../lib/api";
import { toast } from "sonner";

export default function AdminExtensions() {
    const [items, setItems] = useState([]);
    const [tab, setTab] = useState("pending");

    const load = useCallback(
        () => api.get(`/admin/extension-requests?status=${tab}`).then((r) => setItems(r.data || [])),
        [tab],
    );
    useEffect(() => { load(); }, [load]);

    const approve = async (id) => {
        const override = prompt("Approve with how many additional? (Empty = use requested amount)") || "";
        const note = prompt("Admin note? (optional)") || "";
        try {
            const body = { admin_note: note };
            if (override.trim()) body.approved_additional = Number(override);
            const { data } = await api.post(`/admin/extension-requests/${id}/approve`, body);
            const billed = Number(data.cost_delta_usd || 0).toFixed(2);
            toast.success(`Approved (+${data.applied_additional}, billed $${billed})`);
            load();
        } catch (e) {
            toast.error(errorMessage(e));
        }
    };
    const reject = async (id) => {
        const note = prompt("Reason?") || "";
        try {
            await api.post(`/admin/extension-requests/${id}/reject`, { admin_note: note });
            toast.success("Rejected");
            load();
        } catch (e) {
            toast.error(errorMessage(e));
        }
    };

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-7xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">ADMIN · EXTENSION REQUESTS</p>
                <h1 className="h2 mb-8">Advertiser-requested extensions</h1>
                <div className="flex gap-2 mb-6">
                    {["pending", "approved", "rejected"].map((f) => (
                        <button key={f} onClick={() => setTab(f)} className={`btn ${tab === f ? "btn-ink" : "btn-outline"} text-sm py-2 px-3`} data-testid={`adm-ext-tab-${f}`}>
                            {f.toUpperCase()}
                        </button>
                    ))}
                </div>
                <div className="card-base">
                    {items.length === 0 && <div className="p-8 text-center text-sm text-ink-600">No requests.</div>}
                    {items.map((r) => (
                        <div key={r.id} className="px-5 py-4 border-b border-ink-200 last:border-b-0 grid grid-cols-12 gap-3 items-start" data-testid={`adm-ext-${r.id}`}>
                            <div className="col-span-12 md:col-span-5">
                                <div className="font-heading font-bold text-sm">{r.survey_title}</div>
                                <div className="text-xs text-ink-600">{r.advertiser_company || r.advertiser_name}</div>
                                {r.note && <div className="text-xs italic text-ink-600 mt-1">&ldquo;{r.note}&rdquo;</div>}
                            </div>
                            <div className="col-span-6 md:col-span-3 text-sm">
                                <span className="font-mono">+{r.requested_additional}</span>
                                <div className="text-xs text-ink-600">
                                    {r.quota_id ? `bucket: ${r.quota_name || r.quota_id}` : "overall responses"}
                                </div>
                            </div>
                            <div className="col-span-6 md:col-span-2 text-xs font-mono">
                                {new Date(r.created_at).toLocaleDateString()}
                            </div>
                            <div className="col-span-12 md:col-span-2 flex gap-2 flex-wrap justify-end">
                                {r.status === "pending" ? (
                                    <>
                                        <button onClick={() => approve(r.id)} className="btn btn-ink text-xs py-1 px-2" data-testid={`adm-ext-${r.id}-approve`}>Approve</button>
                                        <button onClick={() => reject(r.id)} className="btn btn-outline text-xs py-1 px-2" data-testid={`adm-ext-${r.id}-reject`}>Reject</button>
                                    </>
                                ) : (
                                    <span className={`font-mono text-[10px] px-2 py-1 ${r.status === "approved" ? "bg-success/15 text-success" : "bg-error/15 text-error"}`}>
                                        {r.status.toUpperCase()}
                                    </span>
                                )}
                            </div>
                            {r.status === "approved" && (
                                <div className="col-span-12 text-xs text-ink-600 font-mono pl-1">
                                    applied +{r.applied_additional} · billed ${r.cost_delta_usd?.toFixed(2)} {r.admin_note ? "· " + r.admin_note : ""}
                                </div>
                            )}
                            {r.status === "rejected" && r.admin_note && (
                                <div className="col-span-12 text-xs text-ink-600 italic pl-1">&ldquo;{r.admin_note}&rdquo;</div>
                            )}
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
